// Speech input with push-to-talk. Uses the browser's speech recognition (Chrome/Edge). Note: in Chrome the
// audio is processed by Google's speech service – the settings explain this and the feature is opt-in.
// The recognised text goes through the same parser as typed instructions.

type Rec = {
  lang: string; continuous: boolean; interimResults: boolean; maxAlternatives: number;
  start(): void; stop(): void; abort(): void;
  onresult: ((e: { results: ArrayLike<ArrayLike<{ transcript: string }> & { isFinal: boolean }> }) => void) | null;
  onerror: ((e: { error: string }) => void) | null;
  onend: (() => void) | null;
};

export function speechSupported(): boolean {
  return typeof window !== 'undefined' && ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window);
}

export class PushToTalk {
  private rec: Rec | null = null;
  private text = '';
  active = false;
  onInterim: (t: string) => void = () => {};
  onFinal: (t: string) => void = () => {};
  onError: (msg: string) => void = () => {};

  start(): void {
    if (this.active || !speechSupported()) return;
    const W = window as unknown as { SpeechRecognition?: new () => Rec; webkitSpeechRecognition?: new () => Rec };
    const Ctor = W.SpeechRecognition ?? W.webkitSpeechRecognition!;
    const rec = new Ctor();
    rec.lang = 'en-US';
    rec.continuous = true;
    rec.interimResults = true;
    rec.maxAlternatives = 1;
    this.text = '';
    rec.onresult = e => {
      let s = '';
      for (let i = 0; i < e.results.length; i++) s += e.results[i]![0]!.transcript + ' ';
      this.text = s.trim();
      this.onInterim(this.text);
    };
    rec.onerror = e => { if (e.error !== 'aborted' && e.error !== 'no-speech') this.onError(e.error === 'not-allowed' ? 'Mikrofon nicht freigegeben' : `Spracherkennung: ${e.error}`); };
    rec.onend = () => { if (this.active) { this.active = false; if (this.text) this.onFinal(this.text); } };
    this.rec = rec;
    this.active = true;
    try { rec.start(); } catch { this.active = false; }
  }
  stop(): void {
    if (!this.rec) return;
    // give the recogniser a moment to deliver the last words
    const rec = this.rec;
    setTimeout(() => { try { rec.stop(); } catch { /* stopped */ } }, 350);
  }
}
